import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import SectionTitle from '../../atoms/SectionTitle';

const Wrapper = styled.div`
  margin-top: 16px;
`;

const SectionHeader = (props) => {
  const { value } = props;

  return (
    <Wrapper>
      <SectionTitle value={value}>{value}</SectionTitle>
      <hr />
    </Wrapper>
  );
};

SectionHeader.propTypes = {
  value: PropTypes.string.isRequired,
};

export default SectionHeader;
